import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { BRAND } from '../../constants/brand';

import styles from './Button.module.scss';

interface ButtonProps {
  disabled?: boolean;
  noStyles?: boolean;
  className?: string;
  containerClassName?: string;
  type?: 'button' | 'submit';
  onClick?: any;
  label?: string;
}

const Button: FunctionComponent<ButtonProps> = ({
  disabled,
  children,
  className,
  containerClassName,
  onClick,
  label,
  noStyles = false,
  type = 'button',
}) => {
  const buttonClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-button`,
    className,
    { [styles.reset]: true },
    { [styles.button]: !noStyles },
  );

  const containerClass = classNames(containerClassName, {
    [styles.container]: label,
    [styles.flexContainer]: !label,
  });

  return (
    <div className={containerClass}>
      <button
        type={type}
        onClick={onClick}
        className={buttonClass}
        disabled={disabled}
      >
        {children}
      </button>
      {label && (
        <p className={styles.label}>
          <span>{label}</span>
        </p>
      )}
    </div>
  );
};

export default Button;
